import React from 'react';
import '../../../../assets/css/user/home/subscreens/howdoesitwork/HowDoesItWork.css';
import howitwork1Img from '../../../../assets/images/home/howitwork1.jpg'
import howitwork2Img from '../../../../assets/images/home/howitwork2.jpg';
import howitwork3Img from '../../../../assets/images/home/howitwork3.png';
import { FiSearch } from "react-icons/fi";
import { FaClipboardList } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";

const icons = [
  <FiSearch />,
  <FaClipboardList />,
  <MdLocationOn />
]
;
const HowDoesItWork = () => {
  const steps = [
    {
      id: 1,
      number: "1",
      title: "Search For The Equipment You Need",
      description:
        "Browse available tractors, harvesters, and farming tools based on your needs. Use simple filters to quickly find suitable equipment for your land and season.",
      image:
        howitwork1Img,
    },
    { 
      id: 2,
      number: "2",
      title: "Find The Equipment And Order It Online",
      description:
        "Select the required equipment and place your booking easily through the platform. Choose rental duration and confirm your order with a smooth process.",
      image:
        howitwork2Img,
    },
    {
      id: 3,
      number: "3",
      title: "Get The Equipment Shipped To Your Location",
      description:
        "The equipment is delivered directly to your farm at the scheduled time. This ensures timely operations without delays during important farming activities.",
      image: howitwork3Img
        
    },
  ];

  return (
    <section className="how-it-works-section">
      <div className="container">
        <div className="how-it-works-grid">
          {/* LEFT */}
          <div className="left-content">
            <div className="section-header">
              <h2 className="how-section-title">HOW DOES IT WORK</h2>
              
            </div>

            <div className="steps-list">
              {steps.map((step, index) => (
                <div key={step.id} className={`step-item step-${index + 1}`}>
                  <div className="step-number">{step.number}</div>
                  <div className="step-content">
                    <h3 className="step-title">{step.title}</h3>
                    <p className="step-description">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT */}
          <div className="right-content">
  <div className="floating-cards-container">
    {steps.map((step, i) => (
      <div key={step.id} className={`floating-card card-${i + 1}`}>
        <div className="card-inner">
          <img src={step.image} alt={step.title} />
        </div>

        <div className={`arrow-icon arrow-${i + 1}`}></div>
      </div>
    ))}
  </div> 
</div>
        </div>
      </div>
    </section>
  );
};

export default HowDoesItWork;
